import { useTranslation } from "react-i18next";
import { Task } from "../../../../models/entities/task.model";
import { AlertReason } from "../../../../models/entities/alert.model";
import QuickViewPanelWrapper from "../../../../components/quick-view-panel-wrapper/QuickViewPanelWrapper";
import UiTag from "../../../../components/tag/Tag.component";
import { buildAlertPriorityTag } from "../../../../utils/alert-priority";
import { getAlertDetails, getAlertReason } from "../../../../utils/alert-details";

const RequiresAttentionQuickViewPanel = (props: {
	isLoading: boolean;
	isError: boolean;
	alerts: Task[];
	onClickAction: () => void;
}) => {
	const { t } = useTranslation("common");

	if (props.isLoading) {
		return (
			<QuickViewPanelWrapper
				title="PARTICIPANT.DASHBOARD.REQUIRES_ATTENTION.QUICK_VIEW.PANEL_TITLE"
				onClickAction={props.onClickAction}
				isLoading={props.isLoading}
				isError={props.isError}
			>
				<p className="panel-no-data loading">
					<i className="pi pi-spin pi-spinner message-icon"></i>
					{t("PARTICIPANT.DASHBOARD.REQUIRES_ATTENTION.MESSAGES.LOADING")}
				</p>
			</QuickViewPanelWrapper>
		);
	}

	if (props.isError) {
		return (
			<QuickViewPanelWrapper
				title="PARTICIPANT.DASHBOARD.REQUIRES_ATTENTION.QUICK_VIEW.PANEL_TITLE"
				onClickAction={props.onClickAction}
				isLoading={props.isLoading}
				isError={props.isError}
			>
				<p className="panel-no-data has-error">
					{t("PARTICIPANT.DASHBOARD.REQUIRES_ATTENTION.MESSAGES.ERROR")}
				</p>
			</QuickViewPanelWrapper>
		);
	}

	// The card is ALWAYS rendered when empty (Maria's answer #3: hiding it looks like a bug).
	if (props.alerts.length === 0) {
		return (
			<QuickViewPanelWrapper
				title="PARTICIPANT.DASHBOARD.REQUIRES_ATTENTION.QUICK_VIEW.PANEL_TITLE"
				onClickAction={props.onClickAction}
				isLoading={props.isLoading}
				isError={props.isError}
			>
				<p className="panel-no-data">
					{t("PARTICIPANT.DASHBOARD.REQUIRES_ATTENTION.MESSAGES.NO_DATA")}
				</p>
			</QuickViewPanelWrapper>
		);
	}

	return (
		<QuickViewPanelWrapper
			title="PARTICIPANT.DASHBOARD.REQUIRES_ATTENTION.QUICK_VIEW.PANEL_TITLE"
			onClickAction={props.onClickAction}
			isLoading={props.isLoading}
			isError={props.isError}
		>
			<ul className="panel-list">
				{props.alerts.map((alert) => (
					<li
						key={alert.id}
						className="panel-list-item requires-attention-item"
					>
						<div className="requires-attention-item__header">
							<span className="item-label">
								{getAlertReason(t, alert.reason as string)}
							</span>
							<UiTag {...buildAlertPriorityTag(alert.severity)} />
						</div>
						{/* Clamped to 2 lines in CSS (Maria's answer #5: truncate in the card,
	                        full text lives in the tab). Reason / Details / Priority are the three
	                        fields the acceptance criteria asks for. */}
						<span className="item-value requires-attention-item__details">
							{getAlertDetails(
								t,
								alert.reason as AlertReason,
								alert.details as string
							)}
						</span>
					</li>
				))}
			</ul>
		</QuickViewPanelWrapper>
	);
};

export default RequiresAttentionQuickViewPanel;
